import type { TourDefinition } from '../tours.types';

export const FIRMAR_DOCUMENTO_TOUR: TourDefinition = {
  id: 'firmar_documento_help',
  remember: true,
  steps: [
    {
      element: 'body',
      popover: {
        title: 'Firma de documentos',
        description:
          'En esta pantalla debes ingresar tus credenciales de firma para firmar el documento o los documentos que han sido solicitados.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="btn-cambio-scratchcard"]',
      popover: {
        title: 'Cambiar certificado',
        description:
          'Si necesitas firmar con un certificado distinto, puedes cambiar el usuario o scratchcard con el que deseas realizar la firma.',
        side: 'bottom',
        align: 'center',
      },
    },
      {
      element: '[data-tour="btn-previsualizar-documento"]',
      popover: {
        title: 'Ver documento a firmar',
        description:
          'Puedes pre visualizar el documento que se solicita firmar haciendo clic en este botón.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="toggle-firmar-con-imagen"]',
      popover: {
        title: 'Firmar con imagen',
        description:
          'Esta opción te permite utilizar una imagen como firma. Al activarla, se reemplaza el diseño predeterminado de la firma electrónica por una imagen previamente configurada para tu usuario.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="btn-firmar"]',
      popover: {
        title: 'Firmar documentos',
        description:
          'Haz clic en este botón para iniciar el proceso de firma. Al finalizar, recibirás una confirmación cuando la firma se haya completado correctamente.',
        side: 'bottom',
        align: 'center',
      },
    },
  ],
};
